import React from 'react'
import "./banner.scss"



const banner = () => {
     return (
    <div className='background-container'>
    </div>
  )
}

export default banner;